import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

class TokenStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return null;
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.START:
                return action.token;

            case ActionTypes.UPDATE_TOKEN_FINISH:
                return action.token;

            case ActionTypes.UPDATE_TOKEN_FAILED:
                return null;

            case ActionTypes.LOGIN_FINISH:
                return action.token;

            case ActionTypes.LOGOUT:
                return null;

            default:
                return state;
        }
    }
}

export default new TokenStore();



// WEBPACK FOOTER //
// src/stores/TokenStore.js